__turbopack_context__.v({
  "content": "post-body-module__rMqj6G__content",
});
